import { render } from "./CategoryTab.vue?vue&type=template&id=02414899&scoped=true"
import script from "./CategoryTab.vue?vue&type=script&lang=js"
export * from "./CategoryTab.vue?vue&type=script&lang=js"

import "./CategoryTab.vue?vue&type=style&index=0&id=02414899&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02414899"]])

export default __exports__